export default "__VITE_ASSET__dc1bc3db__"